var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.668C19 14.926 17.33 13.445 15 12.895M13 16.668C13 14.458 10.314 12.668 7 12.668C3.686 12.668 1 14.458 1 16.668M13 9.66797C14.0609 9.66797 15.0783 9.24654 15.8284 8.4964C16.5786 7.74625 17 6.72883 17 5.66797C17 4.6071 16.5786 3.58969 15.8284 2.83954C15.0783 2.0894 14.0609 1.66797 13 1.66797M7 9.66797C5.93913 9.66797 4.92172 9.24654 4.17157 8.4964C3.42143 7.74625 3 6.72883 3 5.66797C3 4.6071 3.42143 3.58969 4.17157 2.83954C4.92172 2.0894 5.93913 1.66797 7 1.66797C8.06087 1.66797 9.07828 2.0894 9.82843 2.83954C10.5786 3.58969 11 4.6071 11 5.66797C11 6.72883 10.5786 7.74625 9.82843 8.4964C9.07828 9.24654 8.06087 9.66797 7 9.66797Z",
    stroke: "#727272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.eb463473f7a02bacde05f849403fcfa1.svg";
export { ForwardRef as ReactComponent };